<form [formGroup]="employmentForm" #employmentFormElement>
  <div class="row">
    <section class="data-field col-xl-4">
      <div class="label">
        <span [innerHTML]="'employmentStatus' | translate | safe: 'html'"></span>
      </div>

      <mat-form-field [floatLabel]="'always'" class="select" appearance="outline">
        <mat-select name="employmentstatus"
                    formControlName="employmentStatus">
          <mat-option *ngFor="let status of employmentStatusList" value="{{status.statusValue}}">
            {{ status.statusName | translate }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="isRequiredField('employmentStatus')">
          {{ 'employmentStatusRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </section>

    <ng-container *ngIf="isEmployed()">
      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'employer' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input matInput class="ltr-text" name="employer" formControlName="employer"
                 (change)="updateUser()" oninput="this.value=this.value.replace(/[^A-Za-z0-9_ ]/g,'')">
          <mat-error *ngIf="isRequiredField('employer')">
            {{ 'employerRequired' | translate }}
          </mat-error>

        </mat-form-field>
      </section>

      <div class="w-lg-100"></div>

      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'natureOfBusiness' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" class="select" appearance="outline">
          <mat-select name="natureofbusiness" formControlName="natureOfBusiness"
                      (selectionChange)="onNatureOfBussinessChanged()">
            <mat-option *ngFor=" let nature of natureOfBusinessList" [translate]="'natureOfBusinessValue'"
                        value="{{nature.natureName}}">
              {{ nature.natureName | translate }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isRequiredField('natureOfBusiness')">
            {{ 'natureOfBusinessRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="data-field col-xl-4">
        <div class="label">
          <span [innerHTML]="'occupation' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" class="select" appearance="outline"
                        *ngIf="employmentModel.natureOfBussiness!=='Other'">
          <mat-select name="occupation" formControlName="occupation"
                      (selectionChange)="updateUser()">
            <mat-option *ngFor=" let occupation of getOccupationList()" value="{{occupation}}">
              {{ occupation | translate }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isRequiredField('occupation')">
            {{ 'occupationRequired' | translate }}
          </mat-error>

        </mat-form-field>
        <mat-form-field [floatLabel]="'always'" appearance="outline"
                        *ngIf="employmentModel.natureOfBussiness==='Other'">
          <input matInput name="occupationOther" formControlName="occupationOther"
                 (change)="updateUser()"
                 oninput="this.value=this.value.replace(/[^A-Za-z0-9_ ]/g,'')">
          <mat-error *ngIf="isRequiredField('occupationOther')">
            {{ 'occupationRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <div *ngIf="isSelfEmployed()" class="w-lg-100"></div>

      <section *ngIf="isSelfEmployed()" class="data-field col-xl-8">
         <div class="label">
          <div [innerHTML]="'businessActivity' | translate | safe: 'html'"></div>
          <span class="small">{{ 'businessActivityHint' | translate }}</span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input matInput
                class="business-description-input"
                name="businessDescription"
                formControlName="businessDescription"
                (change)="updateUser()"
                maxlength="256">
          <mat-error *ngIf="isRequiredField('businessDescription')">
            {{ 'BusinessActivityDescriptionRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </ng-container>
  </div>
</form>
